module.exports = __webpack_public_path__ + "img/f4.090ad3f2.png";